export function formatReqUser(user) {
    return `#${user.id} ${user.name} (${user.city})`;
}
